<template>
  <div class="content ht-100v pd-0">
    <main-header txt="Зөрчил">
      <div>
        <DatePicker class="mg-r-10" size="mini"
                v-model="dateStart"
                type="date"
                placeholder="эхлэх огноо">
              </DatePicker>
              <DatePicker class="mg-r-10" size="mini"
                v-model="dateEnd"
                type="date"
                placeholder="Дуусах огноо">
              </DatePicker>
              <a @click="loadDta" role="button" class="btn btn-primary btn-xs">Шинэчлэх</a>
      </div>
    </main-header>
    <div class="content-body">
      <div class="container pd-0-f">
        <div class="card">
          <div class="card-body">
            <table class="table table-bordered table-striped table-sm">
              <thead class="bg-gray-300">
                <tr>
                  <th class="text-center" rowspan="2">Утга</th>
                  <th class="text-center" colspan="2">Хурд</th>
                  <th rowspan="2">Гэрэл</th>
                  <th rowspan="2">1-р эгнээ</th>
                  <th class="text-center" colspan="3">Түр зогсолт</th>
                  <th class="text-center" rowspan="2">Үзлэг</th>
                  <th class="text-center" rowspan="2">Зөөврийн <br /> хурд</th>
                  <th class="text-center" rowspan="2">Нийт</th>
                </tr>
                <tr>
                  <th>EFMS</th>
                  <th>DAHUA</th>

                  <th>Дүүргийн ЗЦХ</th>
                  <th>e-Police</th>
                  <th>Шар шугам</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(l, i) in list" :key="i">
                  <td>{{ l.rowName }}</td>
                  <td class="text-right tx-11">{{l.speedCount.toLocaleString()}}</td>
                  <td class="text-right tx-11"></td>
                  <td class="text-right tx-11">{{l.lightCount.toLocaleString()}}</td>
                  <td class="text-right tx-11">{{l.egnee1Count.toLocaleString()}}</td>
                  <td class="text-right tx-11">{{l.tsagdaaCount.toLocaleString()}}</td>
                  <td class="text-right tx-11">{{l.ePoliceCount.toLocaleString()}}</td>
                  <td class="text-right tx-11">{{l.shugamCount.toLocaleString()}}</td>
                  <td class="text-right tx-11">{{l.vzlegCount.toLocaleString()}}</td>
                  <td class="text-right tx-11">{{l.zoovorCount.toLocaleString()}}</td>
                  <td class="text-right tx-11 font-weight-bold">{{l.sumCount.toLocaleString()}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import VueApexCharts from "vue-apexcharts";

import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker } from "element-ui";

const moment = require("moment");

export default {
  components: {
    DatePicker,
    apexchart: VueApexCharts,
    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      list: [],
      dateStart: moment().startOf("month")
          .format("YYYY/MM/DD"),
      dateEnd: moment().format("YYYY/MM/DD")
    }
  },
  mounted() {
    this.loadDta();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    loadDta() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/PenaltyDailyReport" },
        data: { start: this.dateStart, end: this.dateEnd },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.list = res.data.returnList;
          //console.log('res', res);
        }
      });
    },
  }
}
</script>

<style>
</style>